import { BasicDialog } from '../../../../../components/Dialog/BasicDialog';
import { allCompaniesActionStateJ, selectedKpiCompaniesStateDCJ } from '../AllCompaniesStateJ';
import { useAllKpiCompaniesActions } from './useAllKpiCompaniesActions';
import { AssignTemplateForm } from './AssignTemplateForm';
import { useAtomValue } from 'jotai';

export function AssignModal() {
  const selectedCompanies = useAtomValue(selectedKpiCompaniesStateDCJ);
  const { resetUIState: handleCloseModal } = useAllKpiCompaniesActions();
  const action = useAtomValue(allCompaniesActionStateJ);
  const open = action === 'assign' || action === 'editAssignment';
  return (
    <BasicDialog
      open={open}
      title={`Assign request to ${
        selectedCompanies.length === 1
          ? selectedCompanies.at(0)?.name
          : `${selectedCompanies.length} companies`
      }`}
      onClose={handleCloseModal}
    >
      {open && <AssignTemplateForm />}
    </BasicDialog>
  );
}
